var map = {
	"./account/sm-dark.svg": 63748,
	"./account/sm-light.svg": 55756,
	"./add-research/sm-dark.svg": 53798,
	"./add-research/sm-light.svg": 88278,
	"./admin-environment/sm-dark.svg": 50164,
	"./admin-environment/sm-light.svg": 48284,
	"./ai-chat/sm-dark.svg": 92416,
	"./ai-chat/sm-light.svg": 85904,
	"./ai-prompt/sm-dark.svg": 80452,
	"./ai-prompt/sm-light.svg": 19884,
	"./calendar/sm-dark.svg": 15165,
	"./calendar/sm-light.svg": 48203,
	"./chevron-down/sm-dark.svg": 36393,
	"./chevron-down/sm-light.svg": 42431,
	"./chevron-right/sm-dark.svg": 94721,
	"./chevron-right/sm-light.svg": 52743,
	"./clipboard/sm-dark.svg": 8579,
	"./coins/sm-dark.svg": 54455,
	"./coins/sm-light.svg": 97829,
	"./dashboard/sm-dark.svg": 73641,
	"./dashboard/sm-light.svg": 94911,
	"./database/sm-dark.svg": 17424,
	"./database/sm-light.svg": 37632,
	"./documents/sm-dark.svg": 12247,
	"./documents/sm-light.svg": 85573,
	"./eye-closed/sm-dark.svg": 67071,
	"./eye-closed/sm-light.svg": 56157,
	"./eye-open/sm-dark.svg": 5275,
	"./eye-open/sm-light.svg": 16337,
	"./flow-chart/sm-dark.svg": 2144,
	"./flow-chart/sm-light.svg": 8112,
	"./gear/sm-dark.svg": 9258,
	"./gear/sm-light.svg": 36338,
	"./gift-shop/sm-dark.svg": 18886,
	"./gift-shop/sm-light.svg": 25814,
	"./globe/sm-dark.svg": 25526,
	"./globe/sm-light.svg": 52998,
	"./home/sm-dark.svg": 13634,
	"./home/sm-light.svg": 52186,
	"./info/sm-dark.svg": 82495,
	"./live-mode/sm-dark-animated.svg": 94595,
	"./live-mode/sm-dark.svg": 83079,
	"./logs/sm-dark.svg": 9034,
	"./logs/sm-light.svg": 95986,
	"./newspaper/sm-dark.svg": 77456,
	"./newspaper/sm-light.svg": 40736,
	"./ooh/sm-dark.svg": 14235,
	"./organisation/sm-dark.svg": 10565,
	"./organisation/sm-light.svg": 87075,
	"./organisations/sm-dark.svg": 32804,
	"./organisations/sm-light.svg": 73036,
	"./plug/sm-dark.svg": 63603,
	"./plug/sm-light.svg": 9241,
	"./plus/sm-dark.svg": 51703,
	"./plus/sm-light.svg": 80773,
	"./question/sm-dark.svg": 84207,
	"./question/sm-light.svg": 40909,
	"./questionnaire/sm-dark.svg": 20726,
	"./questionnaire/sm-light.svg": 50598,
	"./radio/sm-dark.svg": 59644,
	"./research-sliders/sm-dark.svg": 5265,
	"./research/sm-dark.svg": 95132,
	"./research/sm-light.svg": 50580,
	"./researches/sm-dark.svg": 41168,
	"./researches/sm-light.svg": 14144,
	"./reviewers-dashboard/sm-dark.svg": 83390,
	"./reviewers-dashboard/sm-light.svg": 77150,
	"./robot/sm-dark.svg": 65901,
	"./robot/sm-light.svg": 13915,
	"./sign-in/sm-dark.svg": 72000,
	"./sign-in/sm-light.svg": 15408,
	"./sign-out/sm-dark.svg": 79359,
	"./sign-out/sm-light.svg": 52285,
	"./similar-items/sm-dark.svg": 21345,
	"./similar-items/sm-light.svg": 57671,
	"./table/sm-dark.svg": 80333,
	"./table/sm-light.svg": 635,
	"./text-edit/sm-dark.svg": 74703,
	"./tv/sm-dark.svg": 44077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;